import { useLocation } from '@tanstack/react-router'

export const useIsActive = (to: string) => {
  const location = useLocation()
  const normalize = (p: string) => p.replace(/\/$/, '') || '/'
  return normalize(location.pathname) === normalize(to)
}
